import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type {
  AlignItemsProps,
  BackgroundProps,
  BorderColorProps,
  BorderProps,
  BorderRadiusProps,
  BorderStyleProps,
  BorderWidthProps,
  DisplayProps,
  MinHeightProps,
  SpaceProps,
  WidthProps,
} from 'styled-system';
import {
  alignItems,
  background,
  border,
  borderColor,
  borderRadius,
  borderStyle,
  borderWidth,
  display,
  minHeight,
  space,
  width,
} from 'styled-system';

import { focusOutlineCSSWithOffset } from '../../theme/styles';
import type { BoxSizingProps, CursorProps } from '../../theme/system-utilities';
import { boxSizing, cursor } from '../../theme/system-utilities';
import type { ButtonBaseProps } from './index';

export const SPINNER_SIZE = 24;

const UnstyledButtonBase = styled.button<
  ButtonBaseProps &
    SpaceProps &
    DisplayProps &
    AlignItemsProps &
    BackgroundProps &
    BorderProps &
    BorderWidthProps &
    BorderStyleProps &
    BorderColorProps &
    BorderRadiusProps &
    CursorProps &
    BoxSizingProps &
    WidthProps &
    MinHeightProps
>`
  ${space};
  ${display};
  ${alignItems};
  ${background};
  ${border};
  ${borderStyle};
  ${borderColor};
  ${borderWidth};
  ${borderRadius}
  ${cursor};
  ${boxSizing};
  ${width};
  ${minHeight};

  ${focusOutlineCSSWithOffset};
`;

export const ButtonBase = (props: ComponentProps<typeof UnstyledButtonBase>) => (
  <UnstyledButtonBase
    display="inline-flex"
    alignItems="center"
    m="sp_0"
    p="sp_0"
    background="none"
    border="none"
    cursor="pointer"
    boxSizing="border-box"
    {...props}
  />
);
